import { logger } from '../../utils/logger';
import {
  Button,
  Card,
  Col,
  Form,
  FormLabel,
  InputGroup,
  Modal,
  Row,
} from 'react-bootstrap';
import CrossSvg from '../../umart_admin/assets/media/close.png';
import clsx from 'clsx';
import { useState } from 'react';
import APICallService from '../../api/apiCallService';
import { buyer, placeOrder } from '../../api/apiEndPoints';
import Validations from '../../utils/validations';
import { success } from '../../Global/toast';
import { placeOrderToast } from '../../utils/toast';
import { Customer, Order } from '../../utils/constants';
import BlankImg from '../../umart_admin/assets/media/avatars/blank.png';
import { CreatableSelectWhite } from '../custom/Select/CreatableSelectWhite';
import { IOption } from '../../types/responseIndex';
const EditCustomerModal = (props: any) => {
  const [loading, setLoading] = useState(false);
  const [fetchLoader, setFetchLoader] = useState(false);
  const [customerDetails, setCustomerDetails] = useState<{
    name: string;
    tinNumber: string;
    vrnNumber: string;
    notificationTags: IOption[];
  }>({
    name: props?.data?.name || '',
    tinNumber: props?.data?.tinNumber || '',
    vrnNumber: props?.data?.vrnNumber || '',
    notificationTags: props?.data?.notificationTags
      ? props?.data?.notificationTags?.map((item: any) => ({
          value: item?.name,
          label: item?.name,
          title: item?.name,
        }))
      : [],
  });
  const [validation, setValidation] = useState<{
    name: boolean;
    tinNumber: boolean;
    vrnNumber: boolean;
  }>({
    name: false,
    tinNumber: false,
    vrnNumber: false,
  });
  const [inputValue, setInputValue] = useState('');
  const handleChange = (value: string, name: string) => {
    const temp: any = { ...customerDetails };
    const tempValidation: any = { ...validation };
    if (name === 'phone') {
      value = value.split('.')[0];
      if (!Validations.allowNumberAndFloat(value)) {
        return;
      }
    }
    if (name === 'tinNumber' || name === 'vrnNumber') {
      value = value.split('.')[0];
      if (value.trim().length > 0 && !Validations.isAlphanumeric(value)) {
        return;
      }
    }
    if (value.trim().length > 0) {
      tempValidation[name] = false;
    } else if (name !== 'tinNumber' && name !== 'vrnNumber') {
      tempValidation[name] = true;
    }
    if (name === 'tinNumber' || name === 'vrnNumber') {
      tempValidation[name] = false;
    }
    temp[name] = value;
    setCustomerDetails(temp);
    setValidation(tempValidation);
  };
  const handleOnKeyPress = async (event: any) => {
    // Allow only numbers
    const key = event.key;
    let validations = await Validations.allowOnlyNumbers(key);
    if (!validations) {
      event.preventDefault();
      return false;
    }
    return true;
  };
  const handleSubmit = async () => {
    const temp = { ...customerDetails };
    let tempValidation = { ...validation };
    tempValidation = {
      name: temp.name.trim().length === 0 || temp.name.trim().length > 45,
      tinNumber:
        temp.tinNumber.trim().length > 0 && temp.tinNumber.trim().length !== 9,
      vrnNumber:
        temp.vrnNumber.trim().length > 0 && temp.vrnNumber.trim().length !== 9,
    };
    const valid = await Validations.validateObject(tempValidation);
    if (valid) {
      setLoading(true);
      const apiCallService = new APICallService(
        buyer.updateCustomer,
        {
          ...temp,
          tinNumber: temp.tinNumber.trim().toUpperCase(),
          vrnNumber: temp.vrnNumber.trim().toUpperCase(),
          notificationTags: temp.notificationTags.map((item) => ({
            name: item.title,
          })),
        },
        { id: props?.data?._id || '' },
        '',
        false,
        '',
        Customer
      );
      const response = await apiCallService.callAPI();
      if (response) {
        success(placeOrderToast.customerUpdated);
        props.onClose();
      }
      setLoading(false);
    }
    setValidation(tempValidation);
  };
  const createOption = (label: string) => ({
    label,
    value: label,
    title: label,
  });
  const handleMultiSelect = (inputValue: string) => {
    let temp = { ...customerDetails };
    const newOption = createOption(inputValue);
    temp.notificationTags.push(newOption);
    setCustomerDetails(temp);
    setInputValue('');
  };
  const handleMultiSelectChange = (inputValue: any) => {
    let temp = { ...customerDetails };
    temp.notificationTags = inputValue;
    setCustomerDetails(temp);
  };
  const handleInputChange = (inputValue: string) => {
    setInputValue(inputValue);
  };
  const handleKeyDown = (event: any) => {
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        if (event.target.value.trimStart().length > 0) {
          const newOption = createOption(event.target.value);
          let temp = { ...customerDetails };
          temp.notificationTags.push(newOption);
          setCustomerDetails(temp);
          setInputValue('');
        }
        event.preventDefault();
    }
  };
  logger.info('vvvvvvvvvv', customerDetails);
  return (
    <Modal
      {...props}
      show={props.show}
      onHide={props.onHide}
      dialogClassName="modal-dialog-centered min-w-lg-794px"
      className="border-r10px"
      centered
      backdrop="static"
    >
      <Modal.Header className="border-bottom-0 pb-0 text-center mx-auto">
        <img
          className="close-inner-top-2"
          width={40}
          height={40}
          src={CrossSvg}
          alt="closebutton"
          onClick={props.onHide}
        />
        <Modal.Title className="fs-26 fw-bolder mw-lg-375px pt-lg-3">
          Edit customer
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="bg-f9f9f9 border">
          <Card.Body>
            <Row className="g-6">
              <Col md={6}>
                <FormLabel className="fs-16 fw-500 text-dark required">
                  Name
                </FormLabel>
                <Form.Control
                  className={clsx(
                    'form-control-custom bg-white',
                    validation.name ? 'border-danger' : ''
                  )}
                  value={customerDetails.name}
                  onChange={(event: any) => {
                    handleChange(event.target.value.trimStart(), 'name');
                  }}
                  placeholder="Enter name"
                />
                {validation.name && (
                  <div className="text-danger fs-12">
                    Name is required and should not exceed 45 characters
                  </div>
                )}
              </Col>
              <Col md={6}>
                <FormLabel className="fs-16 fw-500 text-dark">
                  TIN Number
                </FormLabel>
                <Form.Control
                  className={clsx(
                    'form-control-custom bg-white',
                    validation.tinNumber ? 'border-danger' : ''
                  )}
                  value={customerDetails.tinNumber}
                  onChange={(event: any) => {
                    handleChange(event.target.value.trimStart(), 'tinNumber');
                  }}
                  placeholder="Enter tin number"
                />
              </Col>
              <Col
                xs={12}
                className="mb-4"
              >
                <FormLabel className="fs-16 fw-500 text-dark">
                  Notification Tags
                </FormLabel>
                <CreatableSelectWhite
                  getOptionLabel={(option: any) => {
                    return <>{option.title}</>;
                  }}
                  inputValue={inputValue}
                  placeholder="Enter notification tags"
                  options={customerDetails.notificationTags}
                  isMulti={true}
                  onCreateOption={(event: any) => {
                    handleMultiSelect(event);
                  }}
                  // border={validation[index].bins ? '#e55451' : '#e0e0df'}
                  onChange={(newValue: any) => {
                    handleMultiSelectChange(newValue);
                  }}
                  onInputChange={(newValue: any) => handleInputChange(newValue)}
                  value={customerDetails.notificationTags}
                  indicatorDisplay="none"
                  display="none"
                  menuIsOpen={false}
                  onKeyDown={(event: any, newValue: any) => {
                    handleKeyDown(event);
                  }}
                />
              </Col>
              <Col md={6}>
                <FormLabel className="fs-16 fw-500 text-dark">
                  VRN Number
                </FormLabel>
                <Form.Control
                  className={clsx(
                    'form-control-custom bg-white',
                    validation.vrnNumber ? 'border-danger' : ''
                  )}
                  value={customerDetails.vrnNumber}
                  onChange={(event: any) => {
                    handleChange(event.target.value.trimStart(), 'vrnNumber');
                  }}
                  placeholder="Enter vrn number"
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer className="justify-content-center mb-4 border-top-0">
        <Button
          variant="primary"
          size="lg"
          onClick={handleSubmit}
          disabled={loading}
        >
          {!loading && <span className="indicator-label">Save</span>}
          {loading && (
            <span
              className="indicator-progress"
              style={{ display: 'block' }}
            >
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default EditCustomerModal;
